import { MdErrorOutline } from "react-icons/md";
import { Button } from "./Button";

interface Props {
  onCancel?: () => void;
  onRetry?: () => void;
}
export const ErrorState = ({ onCancel, onRetry }: Props) => {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center">
      <MdErrorOutline size={30} />
      <h2 className="mt-4 text-lg font-semibold">
        コンテンツを読み込めませんでした
      </h2>
      <p className="mt-2 text-sm text-gray-500">
        データの読み込み中に問題が発生しました。後でもう一度お試しください。
      </p>
      <div className="mt-6 flex gap-2">
        <Button variant="outlined" color="primary" className="w-28" onClick={onCancel}>
          閉じる
        </Button>
        <Button buttonType="primary" className="w-28" onClick={onRetry}>再読み込み</Button>
      </div>
    </div>
  );
};
